import { formatDate } from '@/utils/tableColumns';

export default {
  SET_PROCESSOS_AFILIADOS(state, payload) {
    const processos = payload.map((processo) => ({
      ...processo,
      dataEmbarque: processo.dataEmbarque ? formatDate(processo.dataEmbarque) : 'N/I',
      eta: processo.eta ? formatDate(processo.eta) : 'N/I',
      dataChegada: processo.dataChegada ? formatDate(processo.dataChegada) : 'N/I',
    }));

    state.processosAfiliados = processos;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
